const mediaCache = new Map();
export const storeLoadedImageUrlForSize = (id, size, url) => {
    const existing = mediaCache.get(id) ?? {};
    const image = { url, id };
    mediaCache.set(id, { ...existing, [size]: image });
};
export const getLoadedImageUrlForSize = (id, size) => mediaCache.get(id)?.[size];
export const clearLoadedImageUrls = () => {
    mediaCache.clear();
};
export const clearLoadedImageUrlsForId = (id) => {
    mediaCache.delete(id);
};
